
import { useState, ChangeEvent } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Camera } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { User } from "@/types/auth";

interface ProfileImageSectionProps {
  user: User | null;
  profileImage: File | null;
  profileImageUrl: string;
  setProfileImage: (file: File | null) => void;
  setProfileImageUrl: (url: string) => void;
}

export const ProfileImageSection = ({
  user,
  profileImage,
  profileImageUrl,
  setProfileImage,
  setProfileImageUrl
}: ProfileImageSectionProps) => {
  const { toast } = useToast();

  const handleProfileImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      if (file.size > 1024 * 1024) {
        toast({
          title: "Erro",
          description: "A imagem deve ter menos de 1MB",
          variant: "destructive",
        });
        return;
      }
      
      setProfileImage(file);
      // Create a preview
      const reader = new FileReader();
      reader.onload = () => {
        setProfileImageUrl(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="flex items-center gap-6">
      <div className="relative">
        <Avatar className="h-24 w-24">
          <AvatarImage src={profileImageUrl} />
          <AvatarFallback className="text-2xl bg-brand-teal text-white">
            {user?.name?.substring(0, 2).toUpperCase() || "AU"}
          </AvatarFallback>
        </Avatar>
        <label htmlFor="profile-image" className="absolute bottom-0 right-0 bg-primary text-primary-foreground p-1 rounded-full cursor-pointer">
          <Camera className="h-4 w-4" />
          <input 
            type="file" 
            id="profile-image" 
            className="sr-only" 
            accept="image/*"
            onChange={handleProfileImageChange}
          />
        </label>
      </div>
      <div>
        <p className="text-xs text-gray-500 mb-1">
          JPG, GIF ou PNG. Tamanho máximo de 1MB.
        </p>
        {profileImage && (
          <p className="text-xs text-brand-teal">
            Nova imagem selecionada: {profileImage.name}
          </p>
        )}
      </div>
    </div>
  );
};
